// The audio devices the operator picked in the call panel. Device ids are not secret; they are kept in localStorage
// and read by the tab that plays a call (media-host.ts).

export const AUDIO_IN = 'eyeqsoc.audioIn';
export const AUDIO_OUT = 'eyeqsoc.audioOut';

export function audioDevices(): { input: string | null; output: string | null } {
  try {
    return { input: localStorage.getItem(AUDIO_IN), output: localStorage.getItem(AUDIO_OUT) };
  } catch {
    return { input: null, output: null };
  }
}
